import React, { useEffect, useState } from "react";
import { Row, Col, Card, Button, notification, Form, Input, Select } from "antd";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { baseUrl } from "../../config";

const { Item } = Form;
const { Option } = Select;

function PlanForm() {
  const { planId } = useParams(); // Extract planId from URL
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  useEffect(() => {
    // Check if planId exists to determine if it's an update mode
    if (planId) {
      setIsUpdateMode(true);
      fetchDetails();
    }
  }, [planId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/plan/read/${planId}`);
      if (response.data.success) {
        form.setFieldsValue(response.data.result);
      } else {
        notification.info({
          message: "Info",
          description: response.data.message,
          placement: "topRight",
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.info({
        message: "Info",
        description: error.response?.data?.message,
        placement: "topRight",
      });
    }
  };

  const onFinish = async (values) => {
    try {
      if (isUpdateMode) {
        const response = await axios.patch(`${baseUrl}/api/plan/${planId}`, values, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`, // Include access token in headers
          },
        });
        if (response.data.success) {
          notification.success({
            message: "Success",
            description: "Plan updated successfully!",
            placement: "topRight",
          });
          navigate("/plan");
        } else {
          notification.info({
            message: "Info",
            description: response.data.message,
            placement: "topRight",
          });
        }
      } else {
        const response = await axios.post(`${baseUrl}/api/plan`, values, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`, // Include access token in headers
          },
        });
        if (response.status === 200) {
          notification.success({
            message: "Success",
            description: "Plan added successfully!",
            placement: "topRight",
          });
          form.resetFields();
          navigate("/plan");
        } else {
          notification.info({
            message: "Info",
            description: response.data.message,
            placement: "topRight",
          });
        }
      }
    } catch (error) {
      console.error("API error:", error);
      notification.info({
        message: "Info",
        description: error.response?.data?.message,
        placement: "topRight",
      });
    }
  };

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card bordered={false} className="criclebox tablespace mb-24" title={isUpdateMode ? "Update Plan" : "Add Plan"}>
            <Form style={{ padding: "20px" }} form={form} onFinish={onFinish} layout="vertical">
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={12}>
                  <Item label="Name" name="name" rules={[{ required: true, message: "Please enter name" }]}>
                    <Input placeholder="Please enter name" />
                  </Item>
                </Col>
                <Col xs={24} sm={12} lg={12}>
                  <Item label="Description" name="description" rules={[{ required: true, message: "Please enter description" }]}>
                    <Input placeholder="Please enter description" />
                  </Item>
                </Col>
                <Col xs={24} sm={12} lg={12}>
                  <Item label="Price" name="price" rules={[{ required: true, message: "Please enter price" }]}>
                    <Input
                      type="number"
                      placeholder="Please enter price"
                      addonBefore="€" // Prevents negative numbers
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value < 0) {
                          e.target.value = 0; // Reset to 0 if negative
                        }
                      }}
                    />
                  </Item>
                </Col>
                <Col xs={24} sm={12} lg={12}>
                  <Item label="Status" name="isActive" rules={[{ required: true, message: "Please select status" }]}>
                    <Select placeholder="Please select status">
                      <Option value={true}>Active</Option>
                      <Option value={false}>Inactive</Option>
                    </Select>
                  </Item>
                </Col>
              </Row>
              <Row>
                <Col xs={24} sm={12} lg={12}>
                  <Item label="Storage in KB" name="storage" rules={[{ required: true, message: "Please enter Storage" }]}>
                    <Input
                      type="number"
                      placeholder="Please enter storage in KB"
                      min="0"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value < 0) {
                          e.target.value = 0; // Reset to 0 if negative
                        }
                      }}
                    />
                  </Item>
                </Col>
              </Row>
              <Row>
                <Col xs={24} sm={12} lg={8}>
                  <Item>
                    <Button type="primary" htmlType="submit">
                      {isUpdateMode ? "Update" : "Add"}
                    </Button>
                  </Item>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default PlanForm;
